module.exports = __webpack_public_path__ + "static/media/img_zendy02.505dd200.jpeg";